  <template >

 <div    >
     <template>
  <v-container class="grey lighten-5" v-role="'func'">
    <v-btn  class="mx-2" fab dark color="primary" @click="$router.push('menu-estatistica')">
      <v-icon dark>arrow_back</v-icon>
    </v-btn>
     <div class="text-center">
      <v-progress-circular v-if="progresso"
      indeterminate
      color="primary"
    >Aguarde...</v-progress-circular>

   </div>
    <v-row no-gutters>
      <v-col cols="12" md="1" >
         </v-col>
       <v-col cols="12" md="2" >
            <v-select
              v-model="editedItem.descricao"
              item-value="descricao"
              item-text="novadescricao"
              @change="quantAlunoCurso(editedItem.descricao)"
              :items="anoLectivo"
              :disabled="isUpdating"
              filled
              color="blue-grey lighten-2"
              label="Ano Lectivo"
            ></v-select>
          </v-col>
           <v-col cols="12" md="9">

  <input type="radio" name="gender" v-model="row" value="1" @change=" positionLegend (row) "> Área
  <input type="radio" name="gender" v-model="row" value="2" @change="positionLegend (row)"> Barras
  <input type="radio" name="gender" v-model="row" value="3" @change="positionLegend (row)"> Pie
  <input type="radio" name="gender" v-model="row" value="4" @change="positionLegend(row)"> Radar
  <input type="radio" name="gender" v-model="row" value="5" @change="positionLegend(row)"> Line

            </v-col>
    </v-row>

<v-row>
        <v-col >

      <div class="container">
   <Doughnut
      v-if="loaded && row==='1'"
      :chartdata="chartdata"
      :options="options"/>

       <Bar
      v-if="loaded && row==='2'"
      :chartdata="chartdata"
      :options="options"/>

       <Pie
      v-if="loaded && row==='3'"
      :chartdata="chartdata"
      :options="options"/>

       <Radar
      v-if="loaded && row==='4'"
      :chartdata="chartdata"
      :options="options"/>

       <LineChart
      v-if="loaded && row==='5'"
      :chartdata="chartdata"
      :options="options"/>

  </div>

      </v-col>

    </v-row>
  </v-container>
  </template>

 </div>
</template>

<script>
import axios from '../../../plugins/axios'
const ls = require('local-storage')
export default {
  name: 'BarChartContainer',
  components: {
    Doughnut: () => import('../../../components/Area.vue'),
    Bar: () => import('../../../components/Bar.vue'),
    LineChart: () => import('../../../components/Chart.vue'),
    Radar: () => import('../../../components/Radar.vue'),
    Pie: () => import('../../../components/Pie.vue')
  },
  data: () => ({

    row: '1',
    loaded: false,
    progresso: false,
    isUpdating: false,
    quantAlunosCursos: [],
    anoLectivo: [],
    cursos: [],
    quantAlunos: [],
    editedItem: {
      idAnoLectivo: 0,
      descricao: ls.get('anolectivo'),
      status_2: false
    },
    chartdata: {
      labels: [],
      datasets: [
        {
          label: 'Quantidade de alunos no Curso',
          backgroundColor: ['rgba(255, 99, 71, 0.8)', 'rgb(60, 179, 113)', 'rgb(0, 0, 255)', 'rgb(255, 165, 0)', 'rgb(0, 0, 0)', 'rgb(238, 130, 238)', '#663399', '#800000', '#FFA07A'],
          data: [24, 20, 50, 2, 40, 20, 440, 20, 40, 230]
        }
      ]
    },

    options: {
      responsive: true,
      legend: {
        display: true,
        position: 'top',
        labels: {
          fontColor: 'rgb(255, 99, 132)'
        }
      },
      maintainAspectRatio: false
    }
  }),
  created  () {
    this.anoLectivoAll()
    this.quantAlunoCurso(ls.get('anolectivo'))
    this.positionLegend(this.row)
  },
  async mounted () {
    this.loaded = false
    try {
      //  const { userlist } = await fetch('/api/userlist')
      // this.chartdata = ['January', 'February']
      this.loaded = true
    } catch (e) {
      console.error(e)
    }
  },
  methods: {
    positionLegend (row) {
      if (row === '1' || row === '3') {
        this.options.legend.position = 'left'
      } else {
        this.options.legend.position = 'top'
      }
    },
    async anoLectivoAll () {
      try {
        this.anoLectivo = await axios
          .get('/allAnoLectivo/')
          .then(res => res.data)
        this.row = '1'
      } catch (error) {
        console.log('errrrrrrrrrrrrrrrrrrro' + error)
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    async quantAlunoCurso (anolectivo) {
      this.progresso = true

      try {
        this.quantAlunosCursos = await axios
          .get('/quantidadeAlunosPorCurso/' + anolectivo)
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        this.progresso = false
        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      } this.filterQuantCursos()
    },
    filterQuantCursos () {
      this.cursos = []
      this.quantAlunos = []
      for (let index = 0; index < this.quantAlunosCursos.length; index++) {
        this.cursos[index] = (this.quantAlunosCursos[index].descricao)
        this.quantAlunos[index] = (this.quantAlunosCursos[index].quantidade)
      }
      this.chartdata.labels = this.cursos
      this.chartdata.datasets[0].data = this.quantAlunos

      this.loaded = false
      this.$nextTick(() => {
        this.components = this.componentsBar

        this.loaded = true
      })
    }

  }
}

</script>

<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>
